export default Object.freeze({
  ASSOCIATED: 'ASS',
  MANUALLYASSOCIATED: 'MASS',
  ENROLLED: 'ENR'
})
